import React from 'react'

import MaterialDrawer from 'material-ui/Drawer'
import AssignmentIcon from 'material-ui-icons/Assignment'
import EditLocationIcon from 'material-ui-icons/EditLocation'

import List, {
  ListItem,
  ListItemText,
  ListItemIcon
} from 'material-ui/List'

import {
  Link
} from 'react-router-dom'

const Drawer = ({isDrawerOpen, onToggleDrawer, logout}) =>
  <MaterialDrawer
    open={isDrawerOpen}
    onClick={onToggleDrawer}
    onClose={onToggleDrawer}
  >
    <List disablePadding>
      <ListItem button>
        <ListItemIcon>
          <AssignmentIcon />
        </ListItemIcon>
        <Link to='/jobs'>
          <ListItemText primary='Jobs' />
        </Link>
      </ListItem>

      <ListItem button>
        <ListItemIcon>
          <EditLocationIcon />
        </ListItemIcon>
        <Link to='/locations'>
          <ListItemText primary='Locations' />
        </Link>
      </ListItem>

      <ListItem button>
        <ListItemIcon>
          <AssignmentIcon />
        </ListItemIcon>
        <Link to='/payments'>
          <ListItemText primary='Payments' />
        </Link>
      </ListItem>
      <ListItem button>
        <ListItemIcon>
          <AssignmentIcon />
        </ListItemIcon>
        <Link to='/products'>
          <ListItemText primary='Products' />
        </Link>
      </ListItem>
      <ListItem>
        <Link onClick={logout} to='/'>
          <ListItemText primary='Logout' />
        </Link>
      </ListItem>
    </List>
  </MaterialDrawer>

export default Drawer



// WEBPACK FOOTER //
// ./src/app/Drawer.js